/* Optical Incanto — Ray-Ban Meta availability controls.
   In stock first is server-rendered; selection is client-side on one page.
   Event delegation remains active after Shopify AJAX re-renders. */
(function(){
  if (window.__oiMetaAvailabilityBound) return;
  window.__oiMetaAvailabilityBound = true;
  document.addEventListener('click',function(event){
    var button = event.target.closest('[data-oi-meta-filter]');
    if(!button) return;
    var panel=button.closest('[data-oi-meta-filter-panel]');
    if(!panel) return;
    var wrapper=panel.closest('.collection-grid__wrapper');
    if(!wrapper) return;
    var choice=button.getAttribute('data-oi-meta-filter');
    if(['all','available','incoming'].indexOf(choice)===-1) return;
    wrapper.querySelectorAll('[data-oi-meta-stock]').forEach(function(card){
      card.hidden = choice!=='all' && card.getAttribute('data-oi-meta-stock')!==choice;
    });
    panel.querySelectorAll('[data-oi-meta-filter]').forEach(function(item){
      var active=item===button;
      item.classList.toggle('is-active',active);
      item.setAttribute('aria-pressed',active?'true':'false');
    });
  });
})();
